// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__nRowW","loaderSvg":"Loader_loaderSvg__D2o09"};